import { render, staticRenderFns } from "./infoFeedback.vue?vue&type=template&id=b3e30e8e&scoped=true&"
import script from "./infoFeedback.vue?vue&type=script&lang=js&"
export * from "./infoFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e30e8e",
  null
  
)

export default component.exports